import { COLORS } from 'Components/foundation';
import { createStyleSheet } from 'Components/foundation/stylesheets';

export const stylesheet = createStyleSheet({
  container: {
    position: 'relative',
    width: '280px',
    flexShrink: 0,
  },
  menu: {
    position: 'sticky',
    top: '122px', // 20px + 48px and 54px for mithril menus
    left: '24px',
    width: '256px',
    borderRadius: '12px',
    padding: '24px',
    gap: '8px',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: COLORS.WHITE.DEFAULT,
  },
});

export default stylesheet;
